// Configuração da balança DESTE computador (a balança fica plugada num
// computador só): marca, porta e parâmetros do cabo. Fica no navegador/Núcleo
// Desktop daquele computador. O que vale para a loja inteira (modo automático
// ou manual, peso mínimo, módulos, produto da pesagem rápida) fica no servidor,
// em Preferências (preferencias.js).
import { marcaPorId } from "./protocolo";

const CHAVE = "nucleo:balanca:v1";
const EVENTO = "nucleo:balanca-config";

export const CONFIG_PADRAO = {
  ativa: false,
  conexao: "cabo", // "cabo" | "simulador"
  marca: "toledo",
  ...paramsDaMarca("toledo"),
  casas: 3,
  porta: null, // { usbVendorId, usbProductId, nome }
};

export function paramsDaMarca(id) {
  const m = marcaPorId(id);
  return { baudRate: m.baudRate, dataBits: m.dataBits, parity: m.parity, stopBits: m.stopBits, pedirPeso: m.pedirPeso };
}

export function lerConfig() {
  try {
    const salvo = JSON.parse(localStorage.getItem(CHAVE) || "null");
    return salvo ? { ...CONFIG_PADRAO, ...salvo } : { ...CONFIG_PADRAO };
  } catch {
    return { ...CONFIG_PADRAO };
  }
}

export function salvarConfig(cfg) {
  try {
    localStorage.setItem(CHAVE, JSON.stringify(cfg));
  } catch {
    /* sem armazenamento: vale só nesta abertura */
  }
  window.dispatchEvent(new CustomEvent(EVENTO, { detail: cfg }));
  return cfg;
}

export function aoMudarConfig(fn) {
  const h = (e) => fn(e.detail || lerConfig());
  window.addEventListener(EVENTO, h);
  return () => window.removeEventListener(EVENTO, h);
}

/** Este computador tem balança ligada e pronta para ler? */
export function balancaLigadaAqui(cfg = lerConfig()) {
  if (!cfg.ativa) return false;
  if (cfg.conexao === "simulador") return true;
  return typeof navigator !== "undefined" && !!navigator.serial;
}
